import { PushEncartsVerts } from '@components/push-encarts-verts/models';
import { Block } from '@shared/models';

export const pushEncartsVertsMock: Block<PushEncartsVerts> = {
  type: 'push-encarts-verts',
  data: {
    insets: [
      {
        url: '/mock-espace-franchise/contact',
        title: 'Prêts à vous lancer ?',
        text: "Contactez nos développeurs pour plus d'infos !",
      },
      {
        url: '/mock-espace-franchise',
        title: "Découvrez l’ADN [[SoCoo'c]]",
        text: 'Chaque jour, nous faisons bouger les lignes de notre secteur pour apporter clarté et transparence à nos clients.',
      },
    ],
  },
};
